import { Controller } from 'stimulus'
import { useDispatch } from 'stimulus-use'

export default class extends Controller {
  static targets = ['bulkUploadForm', 'bulkUploadSubmitButton', 'bulkUploadFileInput']

  connect() {
    useDispatch(this)
  }

  showContactBulkUploadModal() {
    const event = new CustomEvent('stakeholder-show-contact-bulk-upload-modal')
    window.dispatchEvent(event)
  }

  handleFileChange(event) {
    this.toggleDisabledSubmit()
    this.updateSubmitButtonCopy(event)
  }

  isBulkUploadFormValid() {
    return this.bulkUploadFormTarget.checkValidity()
  }

  toggleDisabledSubmit() {
    this.bulkUploadSubmitButtonTarget.disabled = !this.isBulkUploadFormValid()
  }

  updateSubmitButtonCopy(event) {
    let copy = 'Upload Contacts'

    if (this.isBulkUploadFormValid()) copy = `Upload ${event.detail.file.length} Contact${event.detail.file.length > 1 ? 's' : ''}`
    this.bulkUploadSubmitButtonTarget.innerHTML = copy
  }
}
